<template>
  <div>
  <div class="page_tow">
    <div :class="flag===1?'top_box':'top_box_tow'">
      <div class="left_logo_nav">
        <div class="left_logo_box">
          <img src="../assets/image/index/smallLogo.jpg" style="width: 100%;height: auto" alt=""/>
        </div>
        <div class="left_nav_box">
          <ul style="display: flex;justify-content: space-evenly;align-items: center;margin-left: -3rem;">
            <li class="list_style"><a href="/#index_page" class="list_a_style">首页</a></li>
<!--            <li class="list_style"><a href="/#new_fruits" class="list_a_style">新推产品</a></li>-->
            <li class="list_style"><a href="/#about_us" class="list_a_style">关于我们</a></li>
            <li class="list_style"><a href="/#all_sale" class="list_a_style">全部商品</a></li>
            <li class="list_style"><a href="/#logistics" class="list_a_style">功能展示</a></li>
            <li class="list_style"><a href="/#join_us" class="list_a_style">加入会员</a></li>
            <li class="list_style"><a href="/#contact_us" class="list_a_style">联系我们</a></li>
          </ul>
        </div>
      </div>
      <div class="right_car_store" >
        <div style="cursor: pointer;" @click="seeCar">
          <el-badge :value="allCount" :max="10" class="item" v-if="allCount>0">
            <img src="../assets/image/index/shoppingCart.png" alt="" style="width:1.5rem;height:1.25rem"/>
          </el-badge>

          <img src="../assets/image/index/shoppingCart.png" alt="" style="width:1.5rem;height:1.25rem" v-else/>
<!--          <img src="../assets/image/index/shoppingCart.png" alt="" style="width:1.5rem;height:1.25rem"/>-->
<!--          <span>{{allCount}}</span>-->
        </div>
        <button :class="flag===1?'show_store_btn':'other_store_btn'">查看商店</button>
      </div>
    </div>
    <div class="commodity_detail_box">
      <div class="turn_next_page" @click="previousPage">
        <img src="../assets/image/index/turn.png" style="width: 2rem;height: auto"/>
        <span style="width: 5rem;height: 2rem;line-height: 2rem;text-align: left;display: block;padding: 0 0.5rem">返回上一页</span>
      </div>
      <div class="commodity_detail_content">
        <div class="commodity_detail_image">
          <img :src="commodityList.image" style="width: 100%;height: 35rem; overflow:hidden;object-fit:cover"/>
        </div>
        <div class="commodity_detail_word">
          <div style="font-size: 1.6rem;font-weight: bold;text-align: left;padding: 0.5rem">
            <span>{{commodityList.name}}</span>
          </div>
          <div style="font-size: 1.2rem;padding: 0.5rem">
            <span style="color: black">价格：</span>
            <span style="color: #ff4400">￥{{commodityList.price}}</span>
          </div>
          <div style="font-size: 1rem;padding: 0.5rem;text-decoration:line-through;color: #999" v-if="commodityList.orPrice">
            <span>原价：</span>
            <span>￥{{commodityList.orPrice}}</span>
          </div>
          <div style="width:27rem;font-size: 1.2rem;padding: 1rem 0.5rem;display: flex;flex-direction: row">
            <span style="color: #1B1B1F;display: block;width: 5rem">说明：</span>
            <span  style="color: #72767b;font-size: 1rem;display: block;text-align: left;line-height: 1.2rem;width: 20rem">{{commodityList.introduce}}</span>
          </div>
          <div style="padding: 0.5rem 0">
            <span style="font-size: 1.2rem;padding: 0 0 0 0.5rem">数量：</span>
            <el-input-number v-model="num" @change="handleChange" :min="1" :max="10" label="数量"></el-input-number>
          </div>
          <div style="width: 100%;height: 3rem;display: flex;">
            <button style="width: 15rem;height: 3rem;color: white;margin: 1rem 4.5rem;border: 0;background-color: rgb(253,192,6);font-size: 1.2rem" @click="shopping">加入购物车</button>
          </div>

          <div>

          </div>
        </div>
      </div>
    </div>
    <div class="bottom_about_contact">
      <div class="inside_about_contact">
        <div class="bottom_logo_box">
          <img src="../assets/image/index/logo.jpg" style=" width: 100%;height: auto" alt=""/>
        </div>
        <div class="bottom_about_us">
          <span class="bottom_span_title">关于我们</span>
          <span class="bottom_span_content">我们的理念</span>
          <span class="bottom_span_content">我们的历史</span>
        </div>
        <div class="bottom_contact_us">
          <span class="bottom_span_title">联系我们</span>
          <span class="bottom_span_content">0592-5535810</span>
          <span class="bottom_span_content">hotbuybuy@qq.com</span>
        </div>
        <div class="we_chat_box">
<!--          <img src="../assets/image/index/weChat.png" style="width: 2rem;height: auto"/>-->
        </div>
      </div>
    </div>
    <div class="bottom_icp_box">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" style="text-decoration: none;color: black">闽ICP备20004855号-1</a>
    </div>
  </div>
        <div>
          <el-dialog
            title=""
            :visible.sync="noneCommodity"
            width="20%"
            center
          >
            <span style="display: block;padding: 0.5rem 0;font-size: 1.3rem;font-weight: 500"> 您的购物车为空</span>
            <span slot="footer" class="dialog-footer">
              <el-button style="width: 60%;background: rgb(253,192,6);border: none;color: white" @click="closeCommodity">继续购物</el-button>
            </span>
          </el-dialog>
        </div>
    <shoppingCar  @carDialogClose="carDialogClose" :dialog-table-visible="dialogTableVisible"></shoppingCar>
  </div>
</template>

<script>
  import shoppingCar from "./common/shoppingCar";
    export default {
        name: "detail",
      components:{
        shoppingCar
      },
      data(){
          return{
            flag:1,
            num:0,
            commodityList:{},
            shoppingCarList:[],
            allCount:0,
            dialogTableVisible:false,
            noneCommodity:false
          }
      },

      created(){
          let that=this;
        document.addEventListener('scroll', this.handleScroll);

        that.commodityList=JSON.parse(that.$route.query.data);

        let shoppingCarList=sessionStorage.getItem('shoppingCarList');
        if(shoppingCarList!==undefined && shoppingCarList!==null){
          that.shoppingCarList=JSON.parse(shoppingCarList);
        }else{
          that.shoppingCarList=[];
        }
        that.allCount=sessionStorage.getItem('allCount')? sessionStorage.getItem('allCount'):0;
      },
      methods:{
        handleScroll(){
          let that=this;
          let a = document.getElementsByClassName('page_tow')[0].offsetHeight;
          if(window.pageYOffset>100){
            that.flag=2;
          }else{
            that.flag=1;
          }
        },
        handleChange(value){
          console.log(value);
        },
        previousPage(){
          let that=this;
          that.$router.push('/')
        },
        shopping(){
          let that=this;
          that.commodityList.num=that.num;
          //1.获取缓存上购物车的所有值
          let shoppingCarList=sessionStorage.getItem('shoppingCarList');
          if(shoppingCarList!==undefined && shoppingCarList!==null){
            that.shoppingCarList = JSON.parse(shoppingCarList);
          }else{
            that.shoppingCarList = [];
          }
          //2.循环购物车，看看本次加入购物车的商品是否在购物车里存在
          that.allCount=0;
          if(JSON.stringify(that.shoppingCarList) === '[]' && that.shoppingCarList === []){
            that.shoppingCarList.push(that.commodityList);
            that.allCount=that.commodityList.num;
          }else{
            let flag=0;
            for(let i=0 ; i <= that.shoppingCarList.length-1 ; i++){
               that.allCount += that.shoppingCarList[i].num;
                if(that.shoppingCarList[i].id === that.commodityList.id){
                  that.shoppingCarList[i].num+=that.commodityList.num;
                  flag=1;
                }
            }
            if(flag===0){
              that.shoppingCarList.push(that.commodityList);
            }
            that.allCount+=that.commodityList.num;
          }
          //清除掉原有的缓存，重新存值
          sessionStorage.removeItem("shoppingCarList");
          sessionStorage.removeItem("allCount");
          sessionStorage.setItem('shoppingCarList',JSON.stringify(that.shoppingCarList));
          sessionStorage.setItem('allCount',that.allCount);
        },
        seeCar(){
          let that=this;
          let carList=sessionStorage.getItem('shoppingCarList');
          if(carList!==undefined && carList!==null && carList !== '[]'){
            that.dialogTableVisible=true;
            that.noneCommodity=false;
          }else{
            that.noneCommodity=true;
            that.dialogTableVisible=false;
          }
        },
        closeCommodity(){
          let that=this;
          that.noneCommodity=false;
          that.allCount=sessionStorage.getItem('allCount')? sessionStorage.getItem('allCount'):0;
        },
        carDialogClose(val){
          let that=this;
          that.dialogTableVisible=val;
          that.allCount=sessionStorage.getItem('allCount')? sessionStorage.getItem('allCount'):0;
          console.log(that.allCount);
        }
      },
      beforeDestroy () {
        document.removeEventListener('scroll', this.handleScroll);
      },
      // watch:{
      //     shoppingCarList(newVal,oldVal){
      //       console.log(newVal);
      //       console.log(oldVal);
      //     }
      // }
    }
</script>

<style scoped>
  .top_box{
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .top_box_tow{
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
    border-bottom: 1px solid rgb(217,217,217);
    z-index: 999;
  }
  .left_logo_nav{
    width: 35%;
    height: 5rem;
    display: flex;
    justify-content: space-between;
  }
  .left_logo_box{
    width: 6%;
    height: 5rem;
    padding: 1rem 3rem;
  }
  .left_nav_box{
    width: 80%;
    height: 5rem;
    line-height: 3rem;
  }
  .right_car_store{
    width: 12%;
    height: 5rem;
    color: black;
    display: flex;
    align-items: center;
  }
  .list_style{
    list-style-type: none;
  }

  .list_a_style{
    text-decoration: none;
    cursor:hand;
    color: black;
    font-weight: 600;
  }
  .show_store_btn{
    width: 9rem;
    height: 3rem;
    color: white;
    /*background-color: rgb(221,195,70);*/
    background-color: rgb(253,192,6);
    border: none;
    font-size: 1.2rem;
    font-weight: 600;
    margin-left: 1.6rem;
  }
  .other_store_btn{
    width: 9rem;
    height: 3rem;
    color: black;
    border: none;
    font-size: 1.2rem;
    font-weight: 600;
    margin-left: 1.6rem;
    background-color: transparent;
  }
  .commodity_detail_box{
    width: 88%;
    height: 40rem;
    margin: 7rem  auto;
  }
  .turn_next_page{
    width: 100%;
    height: 2rem;
    display: flex;
    cursor: pointer;
  }
  .commodity_detail_content{
    width: 100%;
    height: 35rem;
    margin-top: 6rem;
    display: flex;
  }
  .commodity_detail_image{
    width: 50%;
    height: 35rem;
    background-color: #72767b;
  }
  .commodity_detail_word{
    width: 40%;
    height: 35rem;
    margin-left: 3rem;
  }
  .bottom_about_contact{
    width: 100%;
    height: 9.75rem;
  }
  .inside_about_contact{
    width: 80%;
    height: 100%;
    margin: 0 auto;
    border-bottom: 1px solid rgb(217,217,217);
    display: flex;
  }
  .bottom_logo_box{
    width: 9rem;
    height: 100%;
  }
  .bottom_about_us{
    width: 6rem;
    height: 75%;
    margin-left: 10rem;
    margin-top: 3%
  }
  .bottom_contact_us{
    width: 9rem;
    height: 75%;
    margin-left: 10rem;
    margin-top: 3%
  }
  .bottom_span_title{
    display: block;
    font-size: 0.85rem;
    font-weight: bolder;
    padding: 0.2rem 0
  }
  .bottom_span_content{
    display: block;
    font-size: 0.85rem;
    padding: 0.2rem 0;
    color: #1B1B1F;
  }
  .we_chat_box{
    width: 2rem;
    height: 2rem;
    margin-left: 30rem;
    margin-top: 4rem;
  }
  .bottom_icp_box{
    width: 100%;
    height: 6rem;
    line-height: 6rem;
    text-align: center;
    color: #555;
    font-size: 0.85rem;
  }
  .think_for_submit{
    width: 7.8rem;
    height: 4rem;
    background-color: rgb(238,238,238);
    color: #777;
    text-align: center;
    line-height: 4rem;
    margin: 0 auto;
  }
  .see_more_commodity{
    width: 100%;
    height: 2rem;
    text-align: center;
    line-height: 2rem;
    padding: 0.5rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/detail.vue